export default __webpack_public_path__ + "static/media/filter.50f2f332.svg";